import L from 'leaflet';

(function() {
  ('use strict');
  const mapDiv = document.getElementById('map');
  let mapIsEmpty = true;
  const TOKEN =
    'pk.eyJ1IjoidmlsY2VrZm91bmRhdGlvbiIsImEiOiJja2JpNWwzeWYwODduMnpxcDlub2kwMmZtIn0.XPrPZnUK5Q3SZ4yg7tyqYg';
  const PATH = `//${location.host}/wp-json/wp/v2/country_of_birth/?hide_empty=true`;
  const DATA = {};
  let map;
  let marker;

  if (mapDiv) {
    /**
     * Append an alert message to the page.
     * @param {string} message
     */
    const errAlert = message => {
      mapDiv.innerHTML = `
        <div class="error-message">
          <div class="l-constrain">
            <h3>Something went wrong and the map failed to load.</h3>
            <p>Try refreshing the page. If the problem persist, you can find a complete
            list of Vilcek's Prizewinners <a href="//${location.host}/prizes/prize-recipients/">here</a>.
          </div>
        </div>
      `;
    };

    /**
     * Reset country layer's styles.
     */
    const utilActiveCountry = () => {
      const countryLayers = document.querySelectorAll('.leaflet-interactive');
      countryLayers.forEach(item => {
        if (item.classList.contains('is-active')) {
          item.classList.remove('is-active');
        }
      });
    };

    /**
     * Filter GeoJson layer based on countries present in the response.
     * @param {String} feature
     */
    const countryExists = feature => {
      // check if country is present
      if (feature.properties.GU_A3 in DATA) {
        return true;
      }
    };

    /**
     * Stryle GeoJson layer.
     * @param {String} feature
     */
    const styleCountry = feature => {
      return {
        fill: false,
        weight: '0.5',
        color: '#666666',
        fillOpacity: '1',
        className: feature.properties.GU_A3,
      };
    };

    /**
     * Make a call to the WP Prizewinner API and retrieve all Prizewinners for a given country.
     * @param {int} id
     * @param {string} code
     */
    const popup = document.getElementById('mapPopup');
    const popupTop = document.querySelector('.popup__top');
    const popupContent = document.querySelector('.popup__content');
    const getCountryPrizeWinners = async (id, code, countryName) => {
      // reset popup content
      popupTop.innerHTML = '';
      popupContent.innerHTML = '';

      popup.dataset.name = code;
      const PATH = `//${location.host}/wp-json/wp/v2/prize_recipients?per_page=100&country_of_birth=${id}&_embed`;
      const res = await fetch(PATH);
      const json = await res.json();

      if (!res.ok) {
        popupContent.innerHTML += `${json.data}`;
      } else {
        try {
          json.data.records.forEach(item => {
            /* eslint-disable */
            const image = 'wp:featuredmedia' in item._embedded ? item._embedded['wp:featuredmedia'][0].link : '/wp-content/themes/gesso/images/default-orange.jpg';
            const alt = 'wp:featuredmedia' in item._embedded ? item._embedded['wp:featuredmedia'][0].alt_text : item.title.rendered;
            const title = item.title.rendered;
            const excerpt = item.acf.map_excerpt ? '<p>' + item.acf.map_excerpt + '</p>' : item.excerpt.rendered;
            popupContent.innerHTML += `
              <div class="popup__winner">
                <a href="${item.link}">
                  <h3 class="popup__name">${title}</h3>
                </a>
                ${ item._embedded['wp:term'][1].length > 0 ?
                  `<p>
                  ${item._embedded['wp:term'][3].length > 0 ? item._embedded['wp:term'][3][0].name : ''}
                  ${item._embedded['wp:term'][1][0].name}
                  ${item._embedded['wp:term'][4].length > 0 ? `in ${item._embedded['wp:term'][4][0].name}` : ''}
                  </p>`
                  :
                  ''
                }
                <img src="${image}" alt="${alt}">
                ${excerpt}
              </div>
            `;
            /* eslint-enable */
          });
        } catch (err) {
          popupContent.innerHTML += `${json.data.error}`;
        }
      }
    };

    /**
     * Bind popup to each country and fill with relevant content.
     *
     * @param {object} layer
     * @param {object} feature
     */
    const createPopup = async (layer, feature) => {
      const id = DATA[feature.properties.GU_A3].id;
      popup.dataset.name = feature.properties.GU_A3;

      layer.addEventListener('click', function(e) {
        utilActiveCountry();
        // const latLngs = [layer.feature.properties.CENTROID];
        // const country = L.latLngBounds(latLngs);
        // map.fitBounds(country, { padding: [200, 200] });

        // get winners
        getCountryPrizeWinners(
          id,
          feature.properties.GU_A3,
          DATA[feature.properties.GU_A3].name
        );

        window.setTimeout(function() {
          const name = DATA[feature.properties.GU_A3].name;
          const description = DATA[feature.properties.GU_A3].description;
          const count = DATA[feature.properties.GU_A3].count;
          popupTop.innerHTML = `
            <h1 class="popup__title">${name}</h1>
            <h4>${count} Prizewinner${count > 1 ? 's' : ''}</h4>
            <p>${description}</p>
          `;

          popup.style.display = 'block';
        }, 400);

        const countryLayer = document.querySelector(
          `.${feature.properties.GU_A3}`
        );

        if (!countryLayer.classList.contains('is-active')) {
          countryLayer.classList.add('is-active');
          document
            .querySelector(`.marker-${feature.properties.GU_A3}`)
            .classList.add('is-active');
        }
      });

      layer.addEventListener('mouseover', function() {
        document
          .querySelector(`.marker-${feature.properties.GU_A3}`)
          .classList.add('hover');
      });

      layer.addEventListener('mouseout', function() {
        document
          .querySelector(`.marker-${feature.properties.GU_A3}`)
          .classList.remove('hover');
      });
    };

    /**
     * Create and bind marker to each country layer.
     *
     * @param {object} layer
     * @param {object} feature
     * @param {array} center
     * @param {int} id
     * @param {int} count
     */
    const createMarker = async (layer, feature, center, id, count) => {
      // Use center to put marker on map
      marker = L.marker(center, {
        icon: L.divIcon({
          className: `marker marker-${feature.properties.GU_A3}`,
          html: `${count}`,
          riseOnHover: true,
          iconSize: [30, 58],
          iconAnchor: [15, 58],
        }),
      });

      // add marker
      map.addLayer(marker);

      const popup = document.getElementById('mapPopup');
      marker.addEventListener('click', function() {
        utilActiveCountry();

        // const latLngs = [layer.feature.properties.CENTROID];
        // const country = L.latLngBounds(latLngs);
        // map.fitBounds(country, { padding: [200, 200] });

        // get winners
        getCountryPrizeWinners(
          id,
          feature.properties.GU_A3,
          DATA[feature.properties.GU_A3].name
        );

        window.setTimeout(function() {
          const name = DATA[feature.properties.GU_A3].name;
          const description = DATA[feature.properties.GU_A3].description;
          const count = DATA[feature.properties.GU_A3].count;
          popupTop.innerHTML = `
          <h1 class="popup__title">${name}</h1>
          <h4>${count} Prizewinner${count > 1 ? 's' : ''}</h4>
          <p>${description}</p>
        `;

          popup.style.display = 'block';
        }, 400);

        document
          .querySelector(`.${feature.properties.GU_A3}`)
          .classList.add('is-active');
        marker.classList.add('is-active');
      });

      marker.addEventListener('mouseover', function() {
        document
          .querySelector(`.${feature.properties.GU_A3}`)
          .classList.add('hover');
      });

      marker.addEventListener('mouseout', function() {
        document
          .querySelector(`.${feature.properties.GU_A3}`)
          .classList.remove('hover');
      });
    };

    /**
     * Create feature popup and marker and bing them to each GeoJson data point.
     * @param {String} feature
     * @param {String} layer
     */
    const featureSettings = (feature, layer) => {
      createPopup(layer, feature);

      const id = DATA[feature.properties.GU_A3].id;
      const center = layer.feature.properties.CENTROID;
      const count = DATA[feature.properties.GU_A3].count;
      createMarker(layer, feature, center, id, count);

      setTimeout(() => {
        loader.style.opacity = 0;
        mapDiv.classList.remove('is-hidden');
      }, 800);

      loader.style.display = 'none';
    };

    /**
     * Use Fetch API to retrieve data from local json file.
     *
     * @param {String} url of the GeoJSON file.
     */
    const fetchGeojson = url => {
      return fetch(url).then(function(res) {
        if (res.ok) {
          return res.json();
        } else {
          return null;
        }
      });
    };

    /**
     * Create the map, import Mapbox styles, set zoom levels and default view.
     */
    const mapSetUp = async () => {
      map = new L.Map('map', {
        maxZoom: 5,
        minZoom: 3,
        noWrap: true,
        continuousWorld: false,
        scrollWheelZoom: false,
        zoomControl: false,
      }).setView([20, 24], 3);

      map.setMaxBounds([
        [-90, -180],
        [90, 180],
      ]);

      // set zoom controls
      new L.Control.Zoom({ position: 'bottomright' }).addTo(map);

      new L.TileLayer(`
        //api.mapbox.com/styles/v1/vilcekfoundation/ckbjgctai2heq1hk0dqnthf42/tiles/256/{z}/{x}/{y}?access_token=${TOKEN}`).addTo(
        map
      );

      /**
       * Import GeoJSON data from local folder.
       */
      fetchGeojson(
        `//${location.host}/wp-content/themes/gesso/js/assets/countries.geojson`
      ).then(data => {
        if (data === null) {
          mapDiv.className = 'map__map';

          errAlert();
          setTimeout(() => {
            loader.style.opacity = 0;
            mapDiv.classList.remove('is-hidden');
          }, 800);

          loader.style.display = 'none';

          return;
        }

        L.geoJSON(data, {
          filter: countryExists,
          style: styleCountry,
          onEachFeature: featureSettings,
        }).addTo(map);
      });
    };

    /**
     * Close popup if a user clicks anywhere on the map other than interfactive layers.
     */
    const closePopUp = () => {
      mapDiv.addEventListener('click', e => {
        if (!e.target.classList.contains('leaflet-interactive')) {
          popup.style.display = 'none';
          utilActiveCountry();
        }
      });
    };

    /**
     * Make a call to the Rest API and retrieve countries.
     */
    const loader = document.querySelector('.loader');
    const initializeMap = async () => {
      const res = await fetch(PATH);
      const json = await res.json();

      if (!res.ok) {
        errAlert();

        setTimeout(() => {
          loader.style.opacity = 0;
          mapDiv.classList.remove('is-hidden');
        }, 800);

        loader.style.display = 'none';

        return;
      }

      if (mapIsEmpty) {
        json.forEach(item => {
          const key = item.acf.country_code;
          const content = {
            id: item.id,
            name: item.name,
            description: item.description,
            count: item.count,
          };
          DATA[key] = content;
        });
        mapSetUp();
      }
      mapIsEmpty = false;
      closePopUp();
    };

    /**
     * Calculate window windth and display map accordingly.
     */
    const checkWindowWidth = () => {
      const popupClose = document.querySelector('.js-close-popup');
      if (window.innerWidth > 959) {
        initializeMap();

        if (popupClose) {
          popupClose.addEventListener('click', () => {
            popupClose.parentNode.style.display = 'none';
            utilActiveCountry();
          });
        }
      } else {
        popupClose.parentNode.style.display = 'none';
      }
    };

    // Runs function once on window resize.
    let timeOut = false;
    window.addEventListener('resize', () => {
      if (timeOut !== false) {
        clearTimeout(timeOut);
      }

      // 200 is time in miliseconds.
      timeOut = setTimeout(checkWindowWidth, 200);
    });

    checkWindowWidth();
  }
})();
